import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App/>, document.getElementById('root'));

document.title = "Marten Tracker | Home";

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js